import { lazy } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import Loadable from 'components/Loadable';
import ProtectedRoute from 'components/ProtectedRoute';
import DashboardLayout from 'layout/Dashboard';

const GenericGestionObras = Loadable(lazy(() => import('pages_FAMILIAS/generic/GestionObras')));
const GenericUnidadesObra = Loadable(lazy(() => import('pages_FAMILIAS/generic/UnidadesObra')));
const GenericUnidadObraCreate = Loadable(lazy(() => import('pages_FAMILIAS/generic/UnidadObraCreate')));
const CreateProyectosPage = Loadable(lazy(() => import('pages_FAMILIAS/components_proyectos/createProyectosPage')));
const StandaloneMaterialSearchPage = Loadable(lazy(() => import('pages_FAMILIAS/components_proyectos/StandaloneMaterialSearchPage')));
const GenericGestionObraInfo = Loadable(lazy(() => import('pages_FAMILIAS/generic/GestionObraInfo')));
const GenericGestionObraArea = Loadable(lazy(() => import('pages_FAMILIAS/generic/GestionObraArea')));
const GenericHomeRedirect = Loadable(lazy(() => import('pages_FAMILIAS/generic/HomeRedirect')));
const PrReportes = Loadable(lazy(() => import('pages_FAMILIAS/pages_PR/reportes')));
const PrReporteDetalle = Loadable(lazy(() => import('pages_FAMILIAS/pages_PR/reportes/Detalle')));

const familyChildren = [
  {
    path: 'pr/reportes',
    element: <PrReportes />
  },
  {
    path: 'pr/reportes/:id',
    element: <PrReporteDetalle />
  },
  {
    path: ':familySlug',
    element: <Outlet />,
    children: [
      { index: true, element: <Navigate to="gestion-obras" replace /> },
      { path: 'home', element: <GenericHomeRedirect /> },
      { path: 'gestion-obras', element: <GenericGestionObras /> },
      { path: 'gestion-proyectos', element: <GenericGestionObras /> },
      { path: 'gestion-proyectos/unidades-obra', element: <GenericUnidadesObra /> },
      { path: 'gestion-proyectos/unidades-obra/crear', element: <GenericUnidadObraCreate /> },
      { path: 'gestion-proyectos/unidades-obra/:codigo', element: <GenericUnidadObraCreate /> },
      { path: 'gestion-proyectos/crear', element: <CreateProyectosPage /> },
      { path: 'gestion-proyectos/crear/materiales', element: <StandaloneMaterialSearchPage /> },
      { path: 'gestion-obras/:obraId', element: <GenericGestionObraInfo /> },
      { path: 'gestion-obras/:obraId/areas/:areaSlug', element: <GenericGestionObraArea /> }
    ]
  }
];

const FamiliasRoutes = {
  path: '/familias',
  element: (
    <ProtectedRoute>
      <DashboardLayout />
    </ProtectedRoute>
  ),
  children: [{ index: true, element: <Navigate to="/areas/gestion" replace /> }, ...familyChildren]
};

export default FamiliasRoutes;
